import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Footer, Text } from 'native-base';
import { styles, C } from '../constants';

import {
  sendLogout
} from '../actions';
class AppFooter extends Component {

  handlerExit = () => {
    this.props.dispatch(sendLogout());
  }
  render() {
    return (
      C.PRODUCT === "RZD" || C.PRODUCT === "RZD_EMPL" ?
        <Footer style={styles.appFooter}>
          <Text style={styles.appFooterText}>&copy; &laquo;РЖД-Медицина&raquo;, 2020</Text>
        </Footer> : null
    );
  }
}

AppFooter.propTypes = {
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = () => ({
});

export default connect(mapStateToProps)(AppFooter);